/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 18:15:38
 * @Description: 检测数据推送路由
 */
const pgsjtsRoutes = {
  path: 'pgsjts',
  name: 'pgsjts',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'pgsjtsIndex',
      component: () => import(/* webpackChunkName: "stsglIndex" */'@/features/xfaqpg/bgts/index.vue'),
      meta: {
        navtabTitle: '评估报告推送',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default pgsjtsRoutes;
